export default __webpack_public_path__ + "static/media/pro-elevate-bbl-1.22ba1c35.png";